import React from 'react';

const AvailableQuizessSkeliton = () => {
  // Create an array to represent rows in the skeleton
  const skeletonRows = Array(5).fill(0);
  
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 animate-pulse">
        <thead>
          <tr className="bg-gray-50">
            {/* Column Headers */}
            {['Title', 'Year', 'Amount', 'Duration', 'Expiry Date', 'Group ID', 'Actions'].map((header, index) => (
              <th key={index} className="px-6 py-3 text-left">
                <div className="h-4 bg-gray-200 rounded w-20"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-100">
          {skeletonRows.map((_, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-gray-50">
              {/* Title Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-5 bg-gray-200 rounded w-32"></div>
                </div>
              </td>
              
              {/* Year Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-5 bg-gray-200 rounded w-16"></div>
                </div>
              </td>
              
              {/* Amount Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-5 bg-gray-200 rounded w-20"></div>
                </div>
              </td>
              
              {/* Duration Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-5 bg-gray-200 rounded w-24"></div>
                </div>
              </td>
              
              {/* Expiry Date Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-5 bg-gray-200 rounded w-28"></div>
                </div>
              </td>
              
              {/* Group ID Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
                  <div className="h-6 bg-gray-200 rounded-full w-24"></div>
                </div>
              </td>
              
              {/* Actions Column */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center text-blue-600">
                  <div className="h-4 w-4 bg-gray-200 rounded mr-1"></div>
                  <div className="h-5 bg-gray-200 rounded w-12"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AvailableQuizessSkeliton;